import _objectSpread from "@babel/runtime/helpers/objectSpread2";
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
var SvgComponent = function SvgComponent(props) {
  return /*#__PURE__*/_jsxs("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), {}, {
    children: [/*#__PURE__*/_jsx("path", {
      d: "M16 7a9 9 0 1 0 0 18 9 9 0 0 0 0-18zM6 16c0-5.523 4.477-10 10-10s10 4.477 10 10-4.477 10-10 10S6 21.523 6 16z",
      clipRule: "evenodd",
      fill: "currentColor",
      fillRule: "evenodd"
    }), /*#__PURE__*/_jsx("path", {
      d: "M13.996 15.017V10h2.597c1.163 0 2.064.279 2.704.78.64.501.96 1.2.96 2.224 0 .544-.09.786-.272 1.181-.181.384-.437.704-.768.96s-.73.557-1.2.674a6.54 6.54 0 0 1-1.584.176h-1.437V18h3.021v.996h-3.021v3h-1v-3H12V18h1.996v-2.005H12v-.978h1.996zm1-4.013v4.013h1.437c.896 0 1.568-.176 2.016-.528.448-.363.672-.706.672-1.485 0-.704-.202-1.157-.608-1.488-.405-.341-1.045-.512-1.92-.512h-1.597z",
      fill: "currentColor"
    })]
  }));
};
export default SvgComponent;